import { render, staticRenderFns } from "./Embrioes.vue?vue&type=template&id=cab6a042&scoped=true"
import script from "./Embrioes.vue?vue&type=script&lang=js"
export * from "./Embrioes.vue?vue&type=script&lang=js"
import style0 from "./Embrioes.vue?vue&type=style&index=0&id=cab6a042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab6a042",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VCardText,VCardTitle,VRow,VSimpleTable})
